import * as React from 'react';

import Start from '../../../../roadmap/components/go/Start';

export default function GoStart() {
    return <Start />;
}
